module.exports = __webpack_public_path__ + "img/vertical_1_1_8011.19fc83da.png";